common.View.create('admin::layouts.galaxy', {

    onDOMLoad() {
        this.initSideBar();
    },

    initSideBar() {
        let sidebar = this.element.find('.admin\\:\\:layouts-main-sidebar-Structure');

        // Check if there are more then one actives in submenu's
        if (sidebar.find('nav > ul > li.active').length > 1) {

            // Remove the first active state.
            sidebar.find('nav > ul > li.active:first-of-type').removeClass('active');
        }
    },
});
